import { useState } from 'react';
import { FileUploader } from './FileUploader';

const { REACT_APP_PROC_BUCKET, REACT_APP_AWS_REGION } = process.env;

const DEVICE_FORMATS = [
  'GoPro Max2',
  'Insta360 X5',
] as const;

const SESSION_TYPES = [
  'Hike',
  'Fish',
  'Motorcycle',
  'Other'
] as const;

type DeviceFormat = typeof DEVICE_FORMATS[number];
type SessionType = typeof SESSION_TYPES[number];

interface Props {
  username: string
}

export const Uploader = ({username}: Props) => {
  const userFolder = username
  const [sessionName, setSessionName] = useState('');
  const [sessionType, setSessionType] = useState<SessionType | ''>('');
  const [selectedFormat, setSelectedFormat] = useState<DeviceFormat | ''>('');

  if (!userFolder) {
    return <div className="container mt-5">Loading user information...</div>;
  }

  const allFieldsFilled = sessionType !== '' && selectedFormat !== '';

  const handleUploadComplete = (files: File[], uploadId: string) => {
    console.log('Upload complete!');
    console.log('Upload ID:', uploadId);
    console.log('Session Name:', sessionName);
    console.log('Session Type:', sessionType);
    console.log('Device Format:', selectedFormat);
    console.log('Files:', files);
  };

  return (
    <div className="container py-4" style={{ maxWidth: '800px', margin: '0 auto' }}>
      {/* Session Fields */}
      <div className="session-fields">
        <div className="session-field">
          <label htmlFor="sessionName" className="session-label">
            Session Name
          </label>
          <input
            id="sessionName"
            type="text"
            className="session-input"
            placeholder="Enter session name..."
            value={sessionName}
            onChange={(e) => setSessionName(e.target.value)}
          />
        </div>

        <div className="session-field">
          <label htmlFor="sessionType" className="session-label">
            Session Type <span className="text-danger">*</span>
          </label>
          <select
            id="sessionType"
            className="session-select"
            value={sessionType}
            onChange={(e) => setSessionType(e.target.value as SessionType | '')}
          >
            <option value="">-- Select a session type --</option>
            {SESSION_TYPES.map((type) => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>

        <div className="session-field">
          <label htmlFor="deviceFormat" className="session-label">
            Device <span className="text-danger">*</span>
          </label>
          <select
            id="deviceFormat"
            className="session-select"
            value={selectedFormat}
            onChange={(e) => setSelectedFormat(e.target.value as DeviceFormat | '')}
          >
            <option value="">-- Select a device --</option>
            {DEVICE_FORMATS.map((format) => (
              <option key={format} value={format}>{format}</option>
            ))}
          </select>
        </div>
      </div>

      {allFieldsFilled ? (
        <FileUploader
          bucketUrl={`https://s3.${REACT_APP_AWS_REGION}.amazonaws.com/${REACT_APP_PROC_BUCKET}`}
          userFolder={userFolder}
          selectedFormat={selectedFormat}
          sessionName={sessionName}
          sessionType={sessionType}
          onUploadComplete={handleUploadComplete}
        />
      ) : (
        <div className="session-warning">
          Please fill in all fields above before uploading files.
        </div>
      )}
    </div>
  );
};
